import { API_URL } from "../../config"
import { getToken } from "../../util/validation"


const token = JSON.parse(getToken);

export async function inviteRenewalMember(formData, menuList){

    try {
        let data = {
            'formData': formData,
            'menuList': menuList,
            'role': 'RMEMBER'
        }

        const response = await fetch(API_URL + 'adminpanel/invite_admin/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token,
            },
            body: JSON.stringify(data),
        })

        if (response.status === 200) {
            return true
        }
        return false
    } catch (error) {
        return false
    }
}

export async function insertMemberTagging(admin_email, segmentList, zoneList, manager){

    try {
        const email = localStorage.getItem('user');

        let data = {
            'email': email,
            'admin_email': admin_email,
            'segmentList': segmentList,
            'zoneList': zoneList,
            'manager': manager
        }

        const response = await fetch(API_URL + 'adminpanel/add_member_tagging/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token,
            },
            body: JSON.stringify(data),
        })

        if (response.status === 200) {
            return true
        }
        return false
    } catch (error) {
        return false
    }
}


export async function getMyDomain(){

    try {

        const email = localStorage.getItem('user')
        var data = { 
            'email': email
        }

        const response = await fetch(API_URL + 'adminpanel/get_my_domain/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }

}

export async function updateRenewalTag(segment, zone, manager, admin_id, user_data){

    try {
        const email = localStorage.getItem('user');

        let data = {

            'email': email,
            'segment': segment,
            'zone': zone,
            'manager': manager,
            'admin_id': admin_id,
            'user_data': user_data
        }

        // console.log(data)

        const response = await fetch(API_URL + 'adminpanel/update_renewal_tags/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token,
            },
            body: JSON.stringify(data),
        })

        if (response.status === 200) {
            return true
        }
        return false
    } catch (error) {
        return false
    }
}

export async function getRenewalAdminDomains(admin){
    try {
        const email = localStorage.getItem('user');

        let data = {

            'email': email,
            'admin_email': admin.admin_email,
            'month': admin.month
        }

        const response = await fetch(API_URL + 'adminpanel/get_renewal_admin_domain/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token,
            },
            body: JSON.stringify(data),
        })

        if (response.status === 200) {
            return response.json()
        }
        return false
    } catch (error) {
        return false
    }
}

export async function getRenewalTeamDomainCount(month) {
    try {
        const email = localStorage.getItem('user');

        let data = {
            'email': email,
            'month': month
        }

        const response = await fetch(API_URL + 'adminpanel/get_renewal_team_domain_count/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token,
            },
            body: JSON.stringify(data),
        })

        if (response.status === 200) {
            return response.json()
        }
        return false
    } catch (error) {
        return false
    }
}

export async function getCurrentMemberDashboard(){
    try {
        const email = localStorage.getItem('user');

        let currentMonth = (new Date().getMonth() + 1).toString() 
        const currentYear = new Date().getFullYear()
        
        if (currentMonth.length < 2) {
            currentMonth = '0' + currentMonth;
        }


        let data = {
            'email': email,
            'month': `${currentYear}-${currentMonth}%`
        }

        const response = await fetch(API_URL + 'adminpanel/get_current_member_dashboard/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token,
            },
            body: JSON.stringify(data),
        })

        if (response.status === 200) {
            return response.json()
        }
        return false
    } catch (error) {
        return false
    }    
}

export async function getCurrentMonthMemberDashboard(comment){
    try {
        const email = localStorage.getItem('user');

        let currentMonth = (new Date().getMonth() + 1).toString() 
        const currentYear = new Date().getFullYear()
        
        if (currentMonth.length < 2) {
            currentMonth = '0' + currentMonth;
        }


        let data = {
            'email': email,
            'month': `${currentYear}-${currentMonth}%`,
            'comment': comment
        }

        const response = await fetch(API_URL + 'adminpanel/get_current_month_member_domains/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token,
            },
            body: JSON.stringify(data),
        })

        if (response.status === 200) {
            return response.json()
        }
        return false
    } catch (error) {
        return false
    }    
}

export async function getResellerRenewalDashboard(month){
    try {
        const email = localStorage.getItem('user');
        

        let data = {
            'email': email,
            'month': month,
        }

        const response = await fetch(API_URL + 'adminpanel/get_reseller_renewal_dashboard/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token,
            },
            body: JSON.stringify(data),
        })

        if (response.status === 200) {
            return response.json()
        }
        return false
    } catch (error) {
        return false
    }    
}